import Topbar from "./../../components/main_topbar/Topbar";
// import style from "./signup.module.css";
import SignupMain from "./../../components/signup_main/signup_main";

function Signup() {
    return (
        <>
            <Topbar />
            <SignupMain />
        </>
    );
}

export default Signup;
